module.exports = __webpack_public_path__ + "6fa8ae1b0645267fe0c5ae739a4b6588.fbx";